export { default } from './src/timer.jsx';